module.exports = __webpack_public_path__ + "static/media/6D.a23cd3cb.svg";